import React, { useState, useEffect, useRef, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CiCamera } from "react-icons/ci";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../assets/css/Ragister.css";
import register from "../assets/images/register.png";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { ThreeDots } from "react-loader-spinner";
import { useLoadScript } from "@react-google-maps/api";
import Swal from "sweetalert2";
import logo from "../assets/images/logo.png";
import userprofile from '../assets/images/userprofile.png'

const Registration = () => {

  // google loation 
  const libraries = ["places"];
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyDBqmAy6HM41cYT7Xvw2jHqVJ8OrWuTObE&libraries=places",
    libraries,
  });

  //loder
  const { promiseInProgress } = usePromiseTracker();

  // Hook
  const navigate = useNavigate();
  const inputRef = useRef(null);

  // toast message function
  const showToastMessage = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  const showToastMessageone = (data) => {
    toast.error(data, {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  // password state and funcation 
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  // state countrycode and countryname
  const [countryCode, setCountryCode] = useState("");
  const [countryName, setCountryName] = useState("");

  // mobile validation funcation 
  const mobilevalidation = (mobile) => {
    if (!new RegExp(/^[0-9+].{6,12}$/).test(mobile)) {
      formik.setFieldError("phone", "Invalid phone number");
    } else {
      formik.setFieldError("phone", "");
    }
  };

  // profile image validation 
  // const [imagesupload, setimagesupload] = useState("");
  const [storeimage, setstoreimage] = useState("");

  // const upload = (event) => {
  //   const imageFile = event.target.files[0];
  //   setimagesupload(imageFile);
  //   setstoreimage(URL.createObjectURL(imageFile));
  //   if (!imageFile) {
  //     toast.success("Please select image")
  //     return false;
  //   } else if (!imageFile.name.match(/\.(jpg|jpeg|png|PNG|JPG|JPEG)$/)) {
  //     toast.success("Please select valid image.")
  //     return false;
  //   }
  // };


  const upload = (event) => {
    const file = event.target.files[0];
    if (file) {
      formik.setFieldValue("imagesupload", file); // Update Formik value
      setstoreimage(URL.createObjectURL(file));
    }
  };

  // sweetalert funcation
  const showAlert = (message, title, successmessage) => {
    Swal.fire({
      title: successmessage || "Alert", // Title is shown at the top
      html: `
        <p>${message}</p>
        <p style="font-weight: bold">${title}</p>`, // Use HTML for more control over the content
      icon: "success",
      confirmButtonText: "OK",
    });
  };

  // api calling for request a quotation
  function handleSubmit(values) {
    const bodyFormData = new FormData();
    bodyFormData.append("name", values.name);
    bodyFormData.append("email", values.email);
    bodyFormData.append("phoneNumber", values.phone.slice(2));
    bodyFormData.append("password", values.newpassword);
    bodyFormData.append("confirm_password", values.confirmpassword);
    bodyFormData.append("aboutMe", values.shortboi);
    bodyFormData.append("dob", values.dob);
    bodyFormData.append("image_1_file", values.imagesupload);
    bodyFormData.append("countryCode", countryCode);
    bodyFormData.append("isCode", countryName);
    bodyFormData.append("currentLocation", values.location);
    bodyFormData.append("currentLat", values.latitude);
    bodyFormData.append("currentLong", values.longitude);
    const url = `${process.env.REACT_APP_BASE_URL}/signup`;
    trackPromise(
      axios
        .post(url, bodyFormData, {
          "Content-Type": "multipart/form-data",
          headers: { Accept: "application/json" },
        })
        .then((response) => {
          if (response.status === 200) {
            showAlert(response.data.message, response.data.successmessage, response.data.title);
            setstoreimage("")
            // setimagesupload("")
          } else if (response.status === 501) {
            showToastMessageone(response.data.message)
          }
        }).catch((error) => {
          if (error.response.status === 422) {
            showToastMessageone(error.response.data.errors.email[0])
            showToastMessageone(error.response.data.errors.name[0])
            showToastMessageone(error.response.data.errors.phoneNumber[0])
            showToastMessageone(error.response.data.errors.password[0])
            showToastMessageone(error.response.data.errors.confirm_password[0])
            showToastMessageone(error.response.data.errors.currentLocation[0])
            showToastMessageone(error.response.data.errors.currentLat[0])
            showToastMessageone(error.response.data.errors.currentLong[0])
            showToastMessageone(error.response.data.errors.dob[0])
            showToastMessageone(error.response.data.errors.countryCode[0])
            showToastMessageone(error.response.data.errors.isCode[0])
            showToastMessageone(error.response.data.errors.aboutMe[0])
            showToastMessageone(error.response.data.errors.image_1_file[0])
          } else if (error.response.status === 501) {
            showToastMessageone(error.response.data.message)
          }
        })
    )
  }

  // email already exists funcation 
  const checkExists = async (value) => {
    try {
      const bodyFormData = new FormData();
      bodyFormData.append("email", value);
      const url = `${process.env.REACT_APP_BASE_URL}/checkemail`;
      const response = await axios.post(url, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
      if (response.data.exists) {
        return true // Exists
      } else {
        return false; // Doesn't exist
      }
    } catch (error) {
      console.error("Error checking email existence:", error);
      return false; // Assume it doesn't exist on error
    }
  };

  // name already exists funcation 
  const checkExistsName = async (value) => {
    try {
      const bodyFormData = new FormData();
      bodyFormData.append("name", value);
      const url = `https://demo.meetupsfellow.com/api/web/checkname`;
      const response = await axios.post(url, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
      if (response.data.exists) {
        return true // Exists
      } else {
        return false; // Doesn't exist
      }

    } catch (error) {
      console.error("Error checking email existence:", error);
      return false; // Assume it doesn't exist on error
    }
  };

  // mobile number already exists funcation 
  const checkExistsMobileNumber = async (value) => {
    try {
      const bodyFormData = new FormData();
      bodyFormData.append("phoneNumber", value.slice(2));
      const url = `https://demo.meetupsfellow.com/api/web/checkphone`;
      const response = await axios.post(url, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
      if (response.data.exists) {
        return true // Exists
      } else {
        return false; // Doesn't exist
      }
    } catch (error) {
      console.error("Error checking email existence:", error);
      return false; // Assume it doesn't exist on error
    }
  };

  // Formik form handler
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      newpassword: "",
      confirmpassword: "",
      shortboi: "",
      phone: "",
      dob: "2006-01-01", // Default value set to January 1, 2006
      location: "",
      latitude: "",
      longitude: "",
      imagesupload: null, // Include image field
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .matches(/^[a-zA-Z0-9]+$/, "This field cannot contain white space and special character").trim()
        .min(2, 'User name is too short!')
        .max(20, 'User name is too long!')
        .required("User name is required!")
        .test("unique-name", "Name already exists",
          async (value) => {
            const UsernameExists = await checkExistsName(value);
            return !UsernameExists;
          }),

      email: Yup.string()
        .trim()
        .ensure()
        .email("Invalid Email Format")
        .required("Email is required!")
        .matches(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          "Email Not Validate"
        ).test(
          "unique-email",
          "Email already exists",
          async (value) => {
            const emailExists = await checkExists(value);
            return !emailExists;
          }),

      phone: Yup.string().required("Phone number is required")
        .test("unique-name", "Name already exists",
          async (value) => {
            const MobileNumberExists = await checkExistsMobileNumber(value);
            return !MobileNumberExists;
          }),

      // dob: Yup.date()
      //   .typeError("Invalid date format")
      //   .required("Date of birth is required")
      //   .max(new Date(), "Date of birth cannot be in the future"), // Optional validation

      dob: Yup.date()
        .typeError("Invalid date format")
        .required("Date of birth is required")
        .max(new Date(), "Date of birth cannot be in the future")
        .test("is-18-years-old", "You must be at least 18 years old", (value) => {
          if (!value) return false; // If value is empty, the required validator handles this
          const today = new Date();
          // console.log(today,"today")
          const birthDate = new Date(value);
          // console.log(birthDate,"birthDate")
          const age = today.getFullYear() - birthDate.getFullYear();
          // console.log(age,"age")
          const isBeforeBirthday = today < new Date(birthDate.setFullYear(today.getFullYear()));
          // console.log(isBeforeBirthday,"isBeforeBirthday")
          return age > 18 || (age === 18 && !isBeforeBirthday);
        }),

      newpassword: Yup.string()
        .trim()
        .ensure()
        .required("Password is required!")
        .min(6, "Password must be at least 6 characters long!")
        .max(12, "Password cannot exceed 12 characters!"),

      confirmpassword: Yup.string()
        .trim()
        .ensure()
        .oneOf([Yup.ref("newpassword")], "Password's Not Match")
        .required("Confirm password is required!"),

      shortboi: Yup.string()
        .required("Required!"),

      location: Yup.string().required("Location is required!"),

      imagesupload: Yup.mixed()
        .required("Profile image is required")
        .test("fileFormat", "Unsupported Format", (value) => {
          return value && ["image/jpg", "image/jpeg", "image/png"].includes(value.type);
        }),
    }),
    validateOnChange: true, // Validate fields on change
    validateOnBlur: true, // Validate fields on blur
    onSubmit: (values) => {
      handleSubmit(values);
      formik.resetForm();
      setstoreimage("")
      // setimagesupload("")
    },
  });


  // google location funcation
  useEffect(() => {
    if (!isLoaded) {
      console.warn("Google Maps API is not loaded yet.");
      return;
    }
    if (loadError) {
      console.error("Error loading Google Maps API:", loadError);
      return;
    }
    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current);
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        const formattedAddress = place.formatted_address || "";
        // Update Formik values
        formik.setFieldValue("location", formattedAddress);
        formik.setFieldValue("latitude", latitude);
        formik.setFieldValue("longitude", longitude);
      } else {
        console.warn("No geometry available for the selected place.");
      }
    });
    // // Cleanup listeners
    // return () => window.google.maps.event.clearInstanceListeners(autocomplete);
  }, [isLoaded, loadError, formik]);



  return (
    <section className="account-section bg_img mt-3">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            <div className="register-images-new">
              <img src={register} alt="Register" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="padding-top padding-bottom">
              <div className="account-area">
                <div className="row">
                  <div className="col-md-2">
                    <div className="logo-box mt-3">
                      <NavLink to="/">
                        <img src={logo} />
                      </NavLink>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="login-header mb-0">
                      <h3>Pre-registration form</h3>
                      <p>
                        Let's create your profile account by filling out the form below.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="rounded-box">
                      <div className="outer">
                        <div className="inner">
                          <input
                            className="inputfile"
                            type="file"
                            name="pic"
                            accept="image/*"
                            onChange={(e) => {
                              upload(e);
                            }}
                          />
                          <label>
                            <CiCamera />
                          </label>
                        </div>
                      </div>
                      <div className="avatar-preview">
                        <div
                          id="imagePreview"
                          className="flex justify-center items-center"
                        >
                          {storeimage === null || storeimage === "" ? <img src={userprofile} className="reg-img" /> : <img
                            src={storeimage}
                            className="reg-img"
                          />}
                        </div>
                      </div>
                      {formik.touched.imagesupload && formik.errors.imagesupload ? (
                        <p className="error">{formik.errors.imagesupload}</p>
                      ) : null}
                    </div>
                  </div>
                </div>
                <form onSubmit={formik.handleSubmit} className="account-form mb-3">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-2">
                        <label>
                          User Name<span>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter User Name"
                          id="name"
                          name="name"
                          value={formik.values.name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.name && formik.touched.name && (
                          <p className="error">{formik.errors.name}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-2">
                        <label>
                          Email<span>*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter Your Email"
                          id="email"
                          name="email"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.email && formik.touched.email && (
                          <p className="error">{formik.errors.email}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-2">
                        <label>
                          Mobile Number<span>*</span>
                        </label>
                        <PhoneInput
                          country={"us"}
                          placeholder=""
                          value={formik.values.phone}
                          onChange={(phone, countryData) => {
                            // Set phone value
                            formik.setFieldValue("phone", phone);
                            // Validate phone number
                            mobilevalidation(phone);
                            // Extract country code
                            setCountryCode(countryData?.dialCode)
                            setCountryName(countryData?.countryCode)
                          }}
                          onBlur={formik.handleBlur}
                          inputProps={{
                            name: "phone",
                            required: true,
                            autoFocus: false,
                            style: { marginLeft: "0px", width: "100%" },
                          }}
                        />
                        {formik.errors.phone && formik.touched.phone && (
                          <p className="error">{formik.errors.phone}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-2">
                        <label>
                          DOB<span>*</span>
                        </label>
                        {/* <input
                          type="date"
                          id="dob"
                          name="dob"
                          placeholder="Enter Your Date Of Birth"
                          // className={`form-control ${formik.touched.dob && formik.errors.dob ? "is-invalid" : ""
                          //   }`}
                          className="form-control"
                          value={formik.values.dob}
                          onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        /> */}

                        <input
                          type="date"
                          id="dob"
                          name="dob"
                          placeholder="Enter Your Date Of Birth"
                          className={`form-control ${formik.touched.dob && formik.errors.dob ? "is-invalid" : ""}`}
                          value={formik.values.dob}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {/* {formik.errors.dob && formik.touched.dob && (
                          <p className="error">{formik.errors.dob}</p>
                        )} */}
                        {formik.errors.dob && formik.touched.dob && (
                          <p className="error">{formik.errors.dob}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group mb-2">
                        <label>
                          Password<span>*</span>
                        </label>
                        <div className="password-input-container">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control"
                            placeholder="Password"
                            id="newpassword"
                            name="newpassword"
                            value={formik.values.newpassword}
                            onChange={formik.handleChange}
                          />
                          <div
                            className="password-toggle"
                            onClick={togglePasswordVisibility}
                          >
                            {showPassword ? <BsEye /> : <BsEyeSlash />}
                          </div>
                        </div>

                        {formik.errors.newpassword && formik.touched.newpassword && (
                          <p className="error">{formik.errors.newpassword}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-2">
                        <label>
                          Confirm Password<span>*</span>
                        </label>
                        <div className="password-input-container">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            className="form-control"
                            placeholder="Confirm Password"
                            id="confirmpassword"
                            name="confirmpassword"
                            value={formik.values.confirmpassword}
                            onChange={formik.handleChange}
                          />
                          <div
                            className="password-toggle"
                            onClick={toggleConfirmPasswordVisibility}
                          >
                            {showConfirmPassword ? <BsEye /> : <BsEyeSlash />}
                          </div>
                        </div>
                        {formik.errors.confirmpassword && formik.touched.confirmpassword && (
                          <p className="error">{formik.errors.confirmpassword}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-2">
                        <label>
                          Location<span>*</span>
                        </label>
                        {/* <input
                          type="text"
                          ref={inputRef}
                          className="form-control"
                          placeholder="Enter Your Location"
                          name="streetAddress"
                          value={input.streetAddress || ""}
                          onChange={handleChange}
                          // 
                        /> */}
                        {/* {formik.errors.confirmpassword && formik.touched.confirmpassword && (
                          <p className="error">{formik.errors.confirmpassword}</p>
                        )} */}

                        <input
                          type="text"
                          ref={inputRef}
                          // className={`form-control ${formik.errors.location && formik.touched.location ? "is-invalid" : ""
                          //   }`}
                          className="form-control"
                          placeholder="Enter Your Location"
                          name="location"
                          value={formik.values.location}
                          onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        />
                        {formik.errors.location && formik.touched.location && (
                          <p className="error">{formik.errors.location}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-2">
                        <label>
                          Short Bio<span>*</span>
                        </label>
                        <textarea
                          className="form-control"
                          placeholder="Short Bio"
                          id="shortboi"
                          name="shortboi"
                          value={formik.values.shortboi}
                          onChange={formik.handleChange}
                          style={{ height: "100px" }}
                        />
                        {formik.errors.shortboi && formik.touched.shortboi && (
                          <p className="error">{formik.errors.shortboi}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="form-button mt-2">
                    {promiseInProgress ? (
                      <div className="spinner spinner-box">
                        <ThreeDots
                          height="80"
                          width="80"
                          color="#ac216c"
                          ariaLabel="circles-loading"
                          visible={true}
                        />
                      </div>
                    ) : (
                      <>
                        <button type="submit" className="resiter">
                          Register
                        </button>
                      </>
                    )}
                  </div>

                </form>
                <ToastContainer />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Registration;


